export const FETCH_LIST_ROLES_REQUEST = 'FETCH_LIST_ROLES_REQUEST'
export const FETCH_LIST_ROLES_SUCCESS = 'FETCH_LIST_ROLES_SUCCESS'
export const FETCH_LIST_ROLES_FALUIRE = 'FETCH_LIST_ROLES_FALUIRE'
export const SEARCH_ROLE = 'SEARCH_ROLE'
